import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import MutationRequest from '../MutationRequest';

export const UPDATE_CONTENT_EVENT = gql`
  mutation updateEvent(
    $contentEventId: Int!
    $animation: EAnimation
    $animationDirection: EDirection
    $event: EContentEventType
    $eventDirection: EDirection
    $eventTitle: String
    $infinite: Boolean
    $millisecondDelay: Int
    $millisecondSpeed: Int
    $assetId: String
    $backgroundColor: String
    $borderColor: String
    $titleColor: String
    $style: EContentEventStyle
    $triggerStyle: EContentEventTriggerStyle
    $iconHorizontalAlignment: EHorizontalAlignment
  ) {
    contentEvent {
      updateEvent(
        contentEvent: {
          contentEventId: $contentEventId
          animation: $animation
          animationDirection: $animationDirection
          event: $event
          eventDirection: $eventDirection
          eventTitle: $eventTitle
          infinite: $infinite
          millisecondDelay: $millisecondDelay
          millisecondSpeed: $millisecondSpeed
          assetId: $assetId
          backgroundColor: $backgroundColor
          borderColor: $borderColor
          titleColor: $titleColor
          style: $style
          triggerStyle: $triggerStyle
          iconHorizontalAlignment: $iconHorizontalAlignment
        }
      ) {
        id
        entityId
        eventTitle
        event
        eventDirection
        animation
        animationDirection
        iconHorizontalAlignment
        infinite
        backgroundColor
        borderColor
        titleColor
        eventDirection
        asset {
          assetId
          s3Key
        }
      }
    }
  }
`;

const updateContentEventRequest = ({
  contentEventId,
  animation,
  animationDirection,
  event,
  eventDirection,
  eventTitle,
  infinite,
  millisecondDelay,
  millisecondSpeed,
  assetId,
  backgroundColor,
  borderColor,
  titleColor,
  style,
  triggerStyle,
  iconHorizontalAlignment,
  onError,
  onSuccessResult,
}) => (
  <Mutation mutation={UPDATE_CONTENT_EVENT}>
    {(updateEvent, { loading, error, data }) => {
      const variables = {
        contentEventId,
        animation,
        animationDirection,
        event,
        eventDirection,
        eventTitle,
        infinite,
        millisecondDelay,
        millisecondSpeed,
        assetId,
        backgroundColor,
        borderColor,
        titleColor,
        style,
        triggerStyle,
        iconHorizontalAlignment,
      };

      if (error) {
        if (error.networkError) {
          onError(error.networkError.message);
        } else {
          onError(error.message);
        }
      }
      if (data) {
        onSuccessResult(data.contentEvent.updateEvent);
      }

      return <MutationRequest isLoading={loading} mutation={updateEvent} variables={variables} />;
    }}
  </Mutation>
);

updateContentEventRequest.propTypes = {
  contentEventId: PropTypes.number.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
  style: PropTypes.string.isRequired,
  animation: PropTypes.string,
  animationDirection: PropTypes.string,
  assetId: PropTypes.string,
  backgroundColor: PropTypes.string,
  borderColor: PropTypes.string,
  event: PropTypes.string,
  eventDirection: PropTypes.string,
  eventTitle: PropTypes.string,
  // eslint-disable-next-line react/boolean-prop-naming
  infinite: PropTypes.bool,
  millisecondDelay: PropTypes.number,
  millisecondSpeed: PropTypes.number,
  titleColor: PropTypes.string,
  triggerStyle: PropTypes.string,
  iconHorizontalAlignment: PropTypes.string,
};

updateContentEventRequest.defaultProps = {
  animation: 'NONE',
  animationDirection: 'TOP',
  assetId: null,
  backgroundColor: null,
  borderColor: null,
  event: 'NONE',
  eventDirection: 'TOP',
  eventTitle: '',
  infinite: false,
  millisecondDelay: 1000,
  millisecondSpeed: 1000,
  titleColor: '',
  triggerStyle: '',
};

export default updateContentEventRequest;
